import React, { useEffect, useState } from "react";
import './SocialLinks.css';
import socialImage from '../../assets/images/socialLinks.png';


const SocialLinks = () => {

  const message = "Internet, TV por Assinatura, Telefonia Fixa, Internet Rural";

  const [whatsAppLink, setWhatsAppLink] = useState("");

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    const baseURL = "https://wa.me/556222000000";
    const messageParam = encodeURIComponent(`Olá, entre para falar sobre: ${message}`);

    if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/.test(userAgent)) {
      setWhatsAppLink(`whatsapp://send?phone=556222000000&text=${messageParam}`);
    } else {
      setWhatsAppLink(`${baseURL}?text=${messageParam}`);
    }
  }, [message]);

  return (
    <div className="container">
      <div className="row social-container">
        <div className="col-sm-12 col-md-7">
          <div className="social-header">
            <h1>Conecte-se Conosco</h1>
            <p>Siga nossas redes sociais e fique por dentro das novidades!</p>
          </div>

          <div className="social-image">
            <img src={socialImage} alt="Redes Sociais" />
          </div>

          <div className="social-links">
            <a href="https://www.facebook.com/gigabytetelecom" target="_blank" rel="noopener noreferrer" className="facebook">Facebook</a>
            <a href="https://www.instagram.com/gigabytetelecom/" target="_blank" rel="noopener noreferrer" className="instagram">Instagram</a>
            <a href={whatsAppLink} target="_blank" rel="noopener noreferrer" className="whatsapp">Whatsapp</a>
          </div>
          <div>
            teste
          </div>
        </div>
        <div className="col-sm-12 col-md-5">
          <div className="social-header">
            <h1>Conecte-se Conosco</h1>
            <p>Siga nossas redes sociais e fique por dentro das novidades!</p>
          </div>

          <div className="social-image">
            <img src={socialImage} alt="Redes Sociais" />
          </div>

          <div className="social-links">
            <a href="https://www.facebook.com/gigabytetelecom" target="_blank" rel="noopener noreferrer" className="facebook">Facebook</a>
            <a href="https://www.instagram.com/gigabytetelecom/" target="_blank" rel="noopener noreferrer" className="instagram">Instagram</a>
            <a href={whatsAppLink} target="_blank" rel="noopener noreferrer" className="whatsapp">Whatsapp</a>
          </div>
          <div>
            teste
          </div>
        </div>
      </div>
    </div>

  );
};

export default SocialLinks;
